import type { Except } from '@festina-life/core'
import {
  FormikLazyTextInput,
  type FormikLazyTextInputProps,
} from '@festina-life/ui/formikForms'

import { useLazyResolveFormValue } from './useLazyResolveFormValue'
import { useLazyResolveUserInput } from './useLazyResolveUserInput'
import { useOptions } from './useOptions'

type Props = Except<
  FormikLazyTextInputProps,
  'resolveFormValue' | 'resolveUserInput'
>

export const FormikSsnInput = (props: Props) => {
  const { optionsAddOnProps } = useOptions()
  const resolveFormValue = useLazyResolveFormValue()
  const resolveUserInput = useLazyResolveUserInput()

  return (
    <FormikLazyTextInput
      resolveFormValue={resolveFormValue}
      resolveUserInput={resolveUserInput}
      optionsAddOnProps={optionsAddOnProps}
      {...props}
    />
  )
}
